import axios from 'axios';

export type CardInfo = {
  type: string;
  lastDigits: string;
  cardholderName: string;
} | null;

export const getCardInfo = async (stripeCustomerId: string) => {
  const { data: cardInfo } = await axios.get<CardInfo>(`/billing/card_info`, {
    params: {
      stripeCustomerId,
    },
  });

  return cardInfo;
};
